module.exports = __webpack_public_path__ + "img/delete.d8ea8e9e.svg";